const sounds = {
  'attack-lose': {
    volume: 1,
    background: false,
    sources: ['attack-lose.mp3'],
  },
  'attack-win': {
    volume: 1,
    background: false,
    sources: ['attack-win.mp3'],
  },
  'button-basic': {
    volume: 1,
    background: false,
    sources: ['button-basic.mp3'],
  },
  'button-exit': {
    volume: 1,
    background: false,
    sources: ['button-exit.mp3'],
  },
  'button-power': {
    volume: 1,
    background: false,
    sources: ['button-power.mp3'],
  },
  'puzzle-basic-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-basic-destroy.mp3'],
  },
  'puzzle-bomb-activate': {
    volume: 1,
    background: false,
    sources: ['puzzle-bomb-activate.mp3'],
  },
  'puzzle-bullet': {
    volume: 1,
    background: false,
    sources: ['puzzle-bullet.mp3'],
  },
  'puzzle-cage-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-cage-destroy.mp3'],
  },
  'puzzle-bubble-form': {
    volume: 1,
    background: false,
    sources: ['puzzle-bubble-form.mp3'],
  },
  'puzzle-bubble-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-bubble-destroy.mp3'],
  },
  'puzzle-candle-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-candle-destroy.mp3'],
  },
  'puzzle-candle-poke': {
    volume: 1,
    background: false,
    sources: ['puzzle-candle-poke.mp3'],
  },
  'puzzle-combo-bomb-bomb': {
    volume: 1,
    background: false,
    sources: ['puzzle-combo-bomb-bomb.mp3'],
  },
  'puzzle-combo-cube-cube': {
    volume: 1,
    background: false,
    sources: ['puzzle-combo-cube-cube.mp3'],
  },
  'puzzle-combo-cube-replace': {
    volume: 1,
    background: false,
    sources: ['puzzle-combo-cube-replace.mp3'],
  },
  'puzzle-combo-rocket-bomb': {
    volume: 1,
    background: false,
    sources: ['puzzle-combo-rocket-bomb.mp3'],
  },
  'puzzle-combo-rocket-rocket': {
    volume: 1,
    background: false,
    sources: ['puzzle-combo-rocket-rocket.mp3'],
  },
  'puzzle-cube-activate': {
    volume: 1,
    background: false,
    sources: ['puzzle-cube-activate.mp3'],
  },
  'puzzle-cube-spin': {
    volume: 1,
    background: false,
    sources: ['puzzle-cube-spin.mp3'],
  },
  'puzzle-cube-clear': {
    volume: 1,
    background: false,
    sources: ['puzzle-cube-clear.mp3'],
  },
  'puzzle-cube-dismiss': {
    volume: 1,
    background: false,
    sources: ['puzzle-cube-dismiss.mp3'],
  },
  'puzzle-dart': {
    volume: 1,
    background: false,
    sources: ['puzzle-dart.mp3'],
  },
  'puzzle-ice-tap': {
    volume: 1,
    background: false,
    sources: ['puzzle-ice-tap.mp3'],
  },
  'puzzle-door-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-door-destroy.mp3'],
  },
  'puzzle-door-poke-board': {
    volume: 1,
    background: false,
    sources: ['puzzle-door-poke-board.mp3'],
  },
  'puzzle-door-poke-chain': {
    volume: 1,
    background: false,
    sources: ['puzzle-door-poke-chain.mp3'],
  },
  'puzzle-drill': {
    volume: 1,
    background: false,
    sources: ['puzzle-drill.mp3'],
  },
  'puzzle-hat-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-hat-destroy.mp3'],
  },

  'puzzle-hat-destroy-new': {
    volume: 1,
    background: false,
    sources: ['puzzle-hat-destroy-new.mp3'],
  },

  'puzzle-invalid': {
    volume: 1,
    background: false,
    sources: ['puzzle-invalid.mp3'],
  },
  'puzzle-power-block-spawn': {
    volume: 1,
    background: false,
    sources: ['puzzle-power-block-spawn.mp3'],
  },
  'puzzle-power-block-form': {
    volume: 1,
    background: false,
    sources: ['puzzle-power-block-form.mp3'],
  },
  'puzzle-lock-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-lock-destroy.mp3'],
  },
  'puzzle-lock-poke': {
    volume: 1,
    background: false,
    sources: ['puzzle-lock-poke.mp3'],
  },
  'puzzle-lose': {
    volume: 1,
    background: false,
    sources: ['puzzle-lose.mp3'],
  },
  'puzzle-lose-new': {
    volume: 1,
    background: false,
    sources: ['puzzle-lose-new.mp3'],
  },
  'puzzle-panther-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-panther-destroy.mp3'],
  },
  'puzzle-candy-bag-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-candy-bag-destroy.mp3'],
  },
  'puzzle-pipe-poke': {
    volume: 1,
    background: false,
    sources: ['puzzle-pipe-poke.mp3'],
  },
  'puzzle-rocket-activate': {
    volume: 1,
    background: false,
    sources: ['puzzle-rocket-activate.mp3'],
  },

  'puzzle-roulette': {
    volume: 1,
    background: false,
    sources: ['puzzle-roulette.mp3'],
  },
  'puzzle-siren-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-siren-destroy.mp3'],
  },
  'rewards-flying': {
    volume: 1,
    background: false,
    sources: ['rewards-flying.mp3'],
  },
  'sfx-star1': {
    volume: 1,
    background: false,
    sources: ['sfx-star1.mp3'],
  },
  'sfx-star2': {
    volume: 1,
    background: false,
    sources: ['sfx-star2.mp3'],
  },
  'sfx-star3': {
    volume: 1,
    background: false,
    sources: ['sfx-star3.mp3'],
  },
  'puzzle-win-confetti': {
    volume: 1,
    background: false,
    sources: ['puzzle-win-confetti.mp3'],
  },

  'puzzle-fugu-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-fugu-destroy.mp3'],
  },
  'puzzle-fugu-poke': {
    volume: 1,
    background: false,
    sources: ['puzzle-fugu-poke.mp3'],
  },
  'puzzle-block-drop': {
    volume: 1,
    background: false,
    sources: ['puzzle-block-drop.mp3'],
  },
  'puzzle-block-drop2': {
    volume: 1,
    background: false,
    sources: ['puzzle-block-drop2.mp3'],
  },
  'fujiquest-jump': {
    volume: 1,
    background: false,
    sources: ['fujiquest-jump.mp3'],
  },
  'fujiquest-zap': {
    volume: 1,
    background: false,
    sources: ['fujiquest-zap.mp3'],
  },
  'puzzle-crate-destroy': {
    volume: 1,
    background: false,
    sources: ['puzzle-crate-destroy.mp3'],
  },
  'puzzle-doghouse-1-2': {
    volume: 1,
    background: false,
    sources: ['puzzle-doghouse-1-2.mp3'],
  },
  'puzzle-doghouse-2-3': {
    volume: 1,
    background: false,
    sources: ['puzzle-doghouse-2-3.mp3'],
  },
  'puzzle-doghouse-3': {
    volume: 1,
    background: false,
    sources: ['puzzle-doghouse-3.mp3'],
  },
  'puzzle-laser-box-charge': {
    volume: 1,
    background: false,
    sources: ['puzzle-laser-box-charge.mp3'],
  },
  'puzzle-laser-box-shoot': {
    volume: 1,
    background: false,
    sources: ['puzzle-laser-box-shoot.mp3'],
  },
  'puzzle-grass-01': {
    volume: 1,
    background: false,
    sources: ['puzzle-grass-01.mp3'],
  },
  'puzzle-grass-02': {
    volume: 1,
    background: false,
    sources: ['puzzle-grass-02.mp3'],
  },
  'puzzle-grass-03': {
    volume: 1,
    background: false,
    sources: ['puzzle-grass-03.mp3'],
  },
};

export function getMatch2SoundEffects() {
  // At this point we cannot figure out the exact sound based on tests.
  // So we will return all the sound effects. They won't be loaded though, so it's fine.
  return sounds;
}

/**
 * TODO: Should group fx with blocks so we can only load what we need.
 * @returns
 */
export function getMatch2SoundEffectsFiles() {
  return Object.values(sounds).map(
    (sfx) => `assets/sounds/sfx/${sfx.sources[0]}`,
  );
}
